import Vuex from 'vuex';
import Vue from 'vue';

import largeSidebar from './modules/largeSidebar';
import compactSidebar from './modules/compactSidebar';
import themeConfig from './modules/themeConfig';
import authData from './modules/authData';
import verticalSidebar from './modules/verticalSidebar';
import dialog from '@/store/modules/dialog';
import injectIntoAppBar from '@/store/modules/injectIntoAppBar';

import actions from './actions';
import mutations from './mutations';
import getters from './getters';

// Load Vuex
Vue.use(Vuex);

export const CURRENCIES = {
  MMC: 'MMC',
  MQC: 'MQC',
};

export const BANK_IDS = {
  MMC: 6274,
  MQC: 6275,
};

// Create store
export default new Vuex.Store({
  state: {
    barColor: 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)',
    barImage: '/img/escalator_1280.jpg',
    currencies: CURRENCIES,
    bankIds: BANK_IDS,
    playermode: CURRENCIES.MMC,
    drawer: null,
    privateRoomsList: [],
    userFriends: [],
    allUserFriends: [],
    userFriendsAccepted: [],
    userFriendsOnline: [],
    userFriendsOffline: [],
    userFriendsRejected: [],
    userFriendsBlocked: [],
    userFriendsSent: [],
    userFriendsReceived: [],
    allusergameplay: [],
    currentUserID: '',
    gameplayToken: '',
    privateRoomURL: '',
    gamelist: [],
    fullgamedata: [],
    tokenprofiles: [],
    tokensales: [],
    gamerounds: [],
    friendrequests: [],
    friendblocked: [],
    friendrejected: [],
    userBlockedFrom: [],
    paymentCredentials: '',
    tokenmap: [],
    depositMethods: [],
    invoiceData: '',
    withdrawalData: '',
    depositBalance: '',
    orderStatus: null,
    // bonusBalance: '',
    withdrawableBalance: '',
    totalBalance: { balance: { MMC: 0, MQC: 0 } },
    recentPlayed: [],
    roomsPlayerNumber: {},
    userDocs: [], // array of base64
    transHistory: [],
    // bonusHistory: [],
    countryInfo: '',
    packages: '',
    mqtechProfile: '',
    playerInfo: '',
    rels: '',
    groupbalance: 0,
    singlegamedata: [],
    userpurchases: [],
    userwithdraws: [],
    tickets: [],
    systemdata: '',
    loginError: '',
    error: '',
    userSuspended: false,
    user: JSON.parse(localStorage.getItem('user')) || '',
    userReferralRewardsData: { balance: 0, count: 0 },
    globalAffiliateConfig: null,
    sites: [],
    currentUserEmail: '',
    promotionDetails: '',
    signuptemplate: '',
    inactivetemplate: '',
    playerlosstemplate: '',
    promolossamount: '',
    playerbettemplate: '',
    promodaysinactive: '',
    deposittemplate: '',
    withdrawalReservations: [],
    userWithdrawals: [],
    withdrawaltemplate: '',
    purchasetemplate: '',
    sitedeposits: [],
    userdeposits: [],
    systemevents: [],
    estatesums: [],
    usergroups: [],
    loadedSites: [],
    alerts: [],
    challenges: [],
    activeGames: [],
    unseenChallenges: [],
    privateRooms: [],
    acceptedchallenge: [],
    depositusers: [],
    userprofile: '',
    userprofiles: [],
    currentuserwallets: '',
    usergamedata: [],
    topwins: [],
    toploss: [],
    topbets: [],
    isloading: '',
    isOlympusAvailable: false,
    isMultiPlinkoLimitedAvailable: false,
    isRollOrHoldLimitedAvailable: false,
    isEscapeTheCircleLimitedAvailable: false,
    isMobileResolution: false,
    systemsnap: '',
    dailytotals: null,
    sidebar: false,
    gameHistory: [],
    lastPlayedWith: [],
    onlineUsersFromList: [],
    homeUrl: '',
    newNotification: null,
    gameWindow: false,
    referralLink: '',
    allReferrals: [],
    gamesList: {},
    isManualSignIn: false,
    isSocialSignUp: false,
    totalUserWithdrawalRequests: 0,

    walletDialog: {
      value: false,
      tab: 'purchase',
    },

    sumsubAccessToken: '',
    includedRoutes: ['comingsoon'],
    possibleFriends: '',
    privateRoomID: null,
    rakeback: 0,
    // availableBonuses: [],
    // allActiveBonuses: [],
    // unclaimedBonuses: [],
    boughtPackages: {},
    userCheckCompleted: false,

    firebaseToken: null,
    firebaseTokenExpirationTime: null,
    packagesPending: false,
    globalConfig: {},
    pendingFlags: {},
    totalNotificationAmount: 0,

    cashierCurrencies: [],

    isLoggedIn: false,
    isEmailVerificationTab: false,
  },
  getters,
  actions,
  mutations,
  modules: {
    dialog,
    largeSidebar,
    compactSidebar,
    themeConfig,
    authData,
    verticalSidebar,
    injectIntoAppBar,
  },
});
